import {
    MarketAllowance,
    OutcomeAllowance,
    SelectedOutcome,
} from '../types';
import { createAllowancesKey } from '../utils';

export function shouldBeAllowedInPlay(
    outcome1: SelectedOutcome,
    outcome2: SelectedOutcome,
    allowedMarketCombinations: Record<string, Set<MarketAllowance>> | undefined = undefined,
    allowedOutcomeCombinations: Record<string, Set<OutcomeAllowance>> | undefined = undefined,
): boolean {
    const isInPlay = outcome1.isInPlay ?? false;

    const marketCombinationKey = createAllowancesKey(outcome1.marketId, outcome2.marketId);
    const outcomeCombinationKey = createAllowancesKey(outcome1.outcomeId, outcome2.outcomeId);

    let isEnabledInPlay = false;

    if (allowedMarketCombinations && marketCombinationKey in allowedMarketCombinations) {
        const allowances = allowedMarketCombinations[marketCombinationKey];
        if (allowances.size > 0) {
            isEnabledInPlay = Array.from(allowances).some((allowance) => !!allowance.enableInplay);
        } else {
            return false;
        }
    } else if (allowedOutcomeCombinations && outcomeCombinationKey in allowedOutcomeCombinations) {
        const allowances = allowedOutcomeCombinations[outcomeCombinationKey];
        if (allowances.size > 0) {
            isEnabledInPlay = Array.from(allowances).some((allowance) => !!allowance.enableInplay);
        } else {
            return false;
        }
    }

    if (isEnabledInPlay) {
        return true;
    }

    return !isInPlay;
}
